<div *ngIf="heroData" [style.background-image]="'url(' + heroData.srcImage + ')'" class="container">
  <h1 class="hero-title">{{ heroData.heroTitle }}</h1>
  <div class="filter-container">
    <input (click)="toTypeform()" [placeholder]="heroData.placeholder">
    <a target="_blank" [href]="getLink()" class="primary-button filter-button">Search now</a>
  </div>
</div>
